import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';
import { BannerItem } from '../../interfaces/interfaces';
import { BannerdeleteComponent } from '../bannerdelete/bannerdelete.component';
import { BannereditorComponent } from '../bannereditor/bannereditor.component';

@Component({
  selector: 'app-banners',
  templateUrl: './banners.component.html',
  styleUrls: ['./banners.component.scss']
})
export class BannersComponent extends SimpleTableComponent<BannerItem> {

  showBannerEditorModal(bannerItem: BannerItem = null): void {
    this.dialogService.open(BannereditorComponent, {
      header: bannerItem !== null ? 'Banner szerkesztése - ' + bannerItem.name : 'Banner hozzáadása',
      data: {
        bannerId: bannerItem !== null ? bannerItem.id : null
      }
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      this.refreshTable();
    });
  }

  showBannerDeleteModal(bannerItem: BannerItem = null): void {
    this.dialogService.open(BannerdeleteComponent, {
      header: 'Banner törlése - ' + bannerItem.name,
      data: {
        bannerId: bannerItem.id
      }
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      this.refreshTable();
    });
  }

  constructor(
    private apiServiceRef: ApiService,
    private dialogService: DialogService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'banners';
  }
}
